import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var Track = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  vertical-align: bottom;\n\n  background-color: ", ";\n  box-sizing: border-box;\n\n  transition: 0.4s;\n\n  cursor: pointer;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  position: relative;\n  vertical-align: bottom;\n\n  background-color: ", ";\n  box-sizing: border-box;\n\n  transition: 0.4s;\n\n  cursor: pointer;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.hierarchy.h4;
}, function (_a) {
  var size = _a.size;
  return size === 'medium' && MediumSwitchStyle;
}, function (_a) {
  var size = _a.size;
  return size === 'large' && LargeSwitchStyle;
}, function (_a) {
  var checked = _a.checked;
  return checked && ActiveSwitchTrackStyle;
}, function (_a) {
  var disabled = _a.disabled;
  return disabled && DisabledSwitchTrackStyle;
});
var MediumSwitchStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 4rem;\n  height: 2.4rem;\n  border-radius: 1.2rem;\n"], ["\n  width: 4rem;\n  height: 2.4rem;\n  border-radius: 1.2rem;\n"])));
var LargeSwitchStyle = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 5.4rem;\n  height: 3.2rem;\n  border-radius: 1.5rem;\n"], ["\n  width: 5.4rem;\n  height: 3.2rem;\n  border-radius: 1.5rem;\n"])));
var ActiveSwitchTrackStyle = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.accent.default;
});
var DisabledSwitchTrackStyle = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  opacity: 0.4;\n  cursor: not-allowed;\n"], ["\n  opacity: 0.4;\n  cursor: not-allowed;\n"])));
var SWITCH_BUTTON_ACTIVE_POSITION = {
  medium: '1.6rem',
  large: '2.2rem'
};
var SWITCH_BITTON_SHADOW = {
  medium: '0px 2px 4px rgba(0, 0, 0, 0.2)',
  large: '0px 3px 8px rgba(0, 0, 0, 0.2)'
};
var MediumButtonStyle = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 2rem;\n  height: 2rem;\n"], ["\n  width: 2rem;\n  height: 2rem;\n"])));
var LargeButtonStyle = css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 2.8rem;\n  height: 2.8rem;\n"], ["\n  width: 2.8rem;\n  height: 2.8rem;\n"])));
var Button = styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  position: absolute;\n  left: 0.2rem;\n  bottom: 0.2rem;\n\n  border-radius: 50%;\n  background-color: ", ";\n  box-shadow: ", ";\n  content: '';\n\n  transition: 0.4s;\n  transform: translateX(\n    ", "\n  );\n\n  ", "\n  ", "\n"], ["\n  position: absolute;\n  left: 0.2rem;\n  bottom: 0.2rem;\n\n  border-radius: 50%;\n  background-color: ", ";\n  box-shadow: ", ";\n  content: '';\n\n  transition: 0.4s;\n  transform: translateX(\n    ", "\n  );\n\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colorTokens.accent.on;
}, function (_a) {
  var size = _a.size;
  return SWITCH_BITTON_SHADOW[size];
}, function (_a) {
  var checked = _a.checked,
      size = _a.size;
  return checked && SWITCH_BUTTON_ACTIVE_POSITION[size];
}, function (_a) {
  var size = _a.size;
  return size === 'medium' && MediumButtonStyle;
}, function (_a) {
  var size = _a.size;
  return size === 'large' && LargeButtonStyle;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
export { ActiveSwitchTrackStyle, Button, DisabledSwitchTrackStyle, Input, LargeButtonStyle, LargeSwitchStyle, MediumButtonStyle, MediumSwitchStyle, SWITCH_BUTTON_ACTIVE_POSITION, Track, Wrapper };